export default __webpack_public_path__ + "static/media/ja1.c50a5724.jpg";